import { Flex, Spin, Tag, Tooltip, Button, Typography, Empty } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';

import { useConfirm } from '../hooks/useConfirm';
import { useAcceptInvitationMutation, useRejectInvitationMutation, useGetInvitationsListQuery } from '../store/projects';
import { USER_ROLES } from '../constants';
import TgAvatar from './TgAvatar';

const { Title, Text } = Typography;

function InvitationList() {
    const { confirm, confirmModal } = useConfirm();
    const [acceptInvitation] = useAcceptInvitationMutation();
    const [rejectInvitation] = useRejectInvitationMutation();
    const { data, isLoading, error } = useGetInvitationsListQuery();

    const handleAcceptInvitation = async (projectId: number) => {
        const result = await confirm({
            message: 'Вы уверены, что хотите принять приглашение?',
        });

        if (result) {
            await acceptInvitation({ projectId });
        }
    };

    const handleRejectInvitation = async (projectId: number) => {
        const result = await confirm({
            message: 'Вы уверены, что хотите отклонить приглашение?',
        });

        if (result) {
            await rejectInvitation({ projectId });
        }
    };

    if (isLoading) {
        return <Spin />;
    }

    if (error || !data) {
        return <div className="app-empty">Не удалось загрузить приглашения</div>;
    }

    return (
        <div>
            <Title level={5} className="app-page__section-title">
                Приглашения
            </Title>

            {data.message.length === 0 ? (
                <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Нет активных приглашений"
                />
            ) : (
                <div className="app-row-list">
                    {data.message.map((invitation) => (
                        <div key={`${invitation.projectId}-${invitation.user.userId}`} className="app-row">
                            <div className="app-row__main">
                                <TgAvatar user={invitation.user} />
                                <div>
                                    <Text>
                                        <b>{invitation.user.firstName}</b> пригласил(а) вас в{' '}
                                        <b>{invitation.name}</b>
                                    </Text>
                                    <div className="app-row__meta" style={{ marginTop: 4 }}>
                                        <Tag color="green" style={{ margin: 0 }}>
                                            {USER_ROLES[invitation.role]}
                                        </Tag>
                                        <Text type="secondary" style={{ fontSize: 12 }}>
                                            {new Date(invitation.createDate).toLocaleDateString('ru-RU')}
                                        </Text>
                                    </div>
                                </div>
                            </div>

                            <Flex gap={8}>
                                <Tooltip title="Принять">
                                    <Button
                                        type="primary"
                                        icon={<CheckOutlined />}
                                        onClick={() => handleAcceptInvitation(invitation.projectId)}
                                    />
                                </Tooltip>
                                <Tooltip title="Отклонить">
                                    <Button
                                        icon={<CloseOutlined />}
                                        onClick={() => handleRejectInvitation(invitation.projectId)}
                                    />
                                </Tooltip>
                            </Flex>
                        </div>
                    ))}
                </div>
            )}

            {confirmModal}
        </div>
    );
}

export default InvitationList;
